import React, { useState, useEffect } from "react";

import { TextField, Table, TableBody, TableCell, TableContainer, TableRow, Stack, } from "@mui/material";
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoIcon from '@mui/icons-material/Info';
import UButton from "../../components/mui/UButton";
import UDatePickers from "../../components/mui/UDatePickers";
import UTable from "../../components/mui/UTable";
import UTextField from "../../components/mui/UTextField";

import { API, } from "../../config";
import { getAPI, fni18n } from "../../services/commonService";

const guide ="Please check.."

const DashDetail = (props) => {
    const [ search, ] = useState({
      branchName : props.data.storeName,
      branch : props.data.storeCd,
      machineNo : props.data.machId,
    });
    const [ status, setStatus ] = useState({}); // 조회 결과 리스트

    // 초기 화면 로드
    useEffect(() => {
      const getLoadData =  async() => {
          await handleSearch()
      };
      getLoadData();
    }, []);
    const handleSearch = async () => {
      try {
        await getAPI(API.OPER.STATUS, search)
        .then((res) => {
          setStatus(res.data.result[0])
        })
        .catch((err) => {
          console.log("Search Error! ", err);
        })
      } catch (e) {
        console.log(e);
      }
    }
    return (
      <div className="pop-container">
        <div className="contents">
          <Box>
            <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                        <TableRow className="table-row-header">
                            <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                            <TableCell className="table-cell">
                              {/* 기번 선택 */}
                              <TextField size="small" value={search.branchName} disabled />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                            <TableCell className="table-cell">
                              {/* 기번 선택 */}
                              <TextField size="small" value={search.machineNo} disabled />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('일시')}</TableCell>
                            <TableCell className="table-cell">
                              <TextField size="small" value={status.date} disabled />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <div className="search"></div>
          </Box>

          <Stack 
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          >
            <Stack 
            direction="column"
            justifyContent="space-around"
            alignItems="stretch"
            spacing={2}
            >
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('모듈')}</TableCell>
                      <TableCell className="table-cell-title">{fni18n('상태')}</TableCell>
                      {/* <TableCell className="table-cell-title" >{fni18n('코멘트')}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('본체상단문')}</TableCell>
                      {/* <TableCell className="table-cell">{status.dr1}</TableCell> */}
                      <TableCell className="table-cell-c">{statusMessage[0][status.dr1]}</TableCell>
                       {/* <TableCell className="table-cell">{status.dr1==='1'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('하단문')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[0][status.dr2]}</TableCell>
                      {/* <TableCell className="table-cell">{status.dr2==='1'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('사이드카문')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[0][status.dr3]}</TableCell>
                      {/* <TableCell className="table-cell">{status.dr3==='1'?guide:null}</TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('입금RejectBox')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[1][status.lf14]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf14==='1'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('출금RejectBox')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[1][status.lf15]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf15==='1'?guide:null}</TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('명세표JAM')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[2][status.st1]}</TableCell>
                      {/* <TableCell className="table-cell">{status.st1==='1'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('지폐JAM')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[2][status.st2]}</TableCell>
                      {/* <TableCell className="table-cell">{status.st2==='1'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('동전JAM')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[2][status.st3]}</TableCell>
                      {/* <TableCell className="table-cell">{status.st3==='1'?guide:null}</TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            </Stack>
            <Stack 
            direction="column"
            justifyContent="space-around"
            alignItems="stretch"
            spacing={2}
            >
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('모듈')}</TableCell>
                      <TableCell className="table-cell-title">{fni18n('상태')}</TableCell>
                      {/* <TableCell className="table-cell-title" >{fni18n('코멘트')}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('지폐')} ($100)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf2]}</TableCell>
                      {/* <TableCell className="table-cell">{message[4].secondary}</TableCell> */}
                      {/* <TableCell className="table-cell">{status.lf2==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('지폐')} ($50)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf3]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf3==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('지폐')} ($20)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf4]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf4==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('지폐')} ($10)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf5]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf5==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('지폐')} ($5)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf6]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf6==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('지폐')} ($1)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf7]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf7==='2'?guide:null}</TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('출금동전')} (25C)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf10]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf10==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('출금동전')} (10C)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf11]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf11==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('출금동전')} (5C)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf12]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf12==='2'?guide:null}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('출금동전')} (1C)</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf13]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf13==='2'?guide:null}</TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            </Stack>
            <Stack 
            direction="column"
            justifyContent="space-around"
            alignItems="stretch"
            spacing={2}
            >
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('모듈')}</TableCell>
                      <TableCell className="table-cell-title">{fni18n('상태')}</TableCell>
                      {/* <TableCell className="table-cell-title">{fni18n('코멘트')}</TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('카세트')} A {fni18n('조작알림')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[5][status.c1]}</TableCell>
                      {/* <TableCell className="table-cell-c"></TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('카세트')} B {fni18n('조작알림')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[5][status.c2]}</TableCell>
                      {/* <TableCell className="table-cell-c"></TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('카세트')} C {fni18n('조작알림')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[5][status.c3]}</TableCell>
                      {/* <TableCell className="table-cell-c"></TableCell> */}
                    </TableRow>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('카세트')} D {fni18n('조작알림')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[5][status.c4]}</TableCell>
                      {/* <TableCell className="table-cell-c"></TableCell> */}
                    </TableRow>
                    {/* <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('보회함')} {fni18n('조작알림')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[5][status.c5]}</TableCell>
                    </TableRow> */}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('모드')}</TableCell>
                      <TableCell className="table-cell-c">{status.ur4}</TableCell>
                      {/* <TableCell className="table-cell-c"></TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box>
              <TableContainer className="table-container">
                <Table className="table" size="small">
                  <TableBody>
                    <TableRow className="table-row-header">
                      <TableCell className="table-cell-title">{fni18n('명세표')}</TableCell>
                      <TableCell className="table-cell-c">{statusMessage[4][status.lf1]}</TableCell>
                      {/* <TableCell className="table-cell">{status.lf1==='2'?guide:null}</TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            </Stack>
          </Stack>
        </div>
      </div>
          
    );
}
const message = [
    {
      primary: '0',
      secondary: "0 : Close , 1 : Open",
      type:'door'
    },
    {
      primary: '1',
      secondary: `0 : Not Full , 1 : FULL`,
      type:'rejectbox',
    },
    {
      primary: '2',
      secondary: '0 : Not JAM , 1 : JAM',
      type:'jam',
    },
    {
      primary: '3',
      secondary: '0 : Online , 1 : Maintenance Mode',
      type:'mode'
    },
    {
      primary: '4',
      secondary: `0 : Normal , 1 : FULL , 2: Empty , 
      3 : Near Full , 4 : Near Empty
      `,
      type:'box'
    },
  ];
  const statusMessage = [
    {
      0: 'Close',
      1: "Open",//warning
    },
    {
      0: 'Not Full',
      1: `Full`,//warning
    },
    {
      0: 'Normal',
      1: 'Jam',//warning
    },
    {
      0: 'Online',
      1: 'Maintenance Mode',//warning
    },
    {
      0: 'Normal',
      1: 'Full',
      2: 'Empty',//warning
      3: 'Near Full',
      4: 'Near Empty',
    },
    {
      0: 'Normal',
      1: 'Warning',//warning
    },
  ];
export default DashDetail;

